/**
 * Login page component
 * Handles manual login and Google OAuth login.
 * @component
 */

import React, { useState } from "react";
import Sign from "./components/Sign";
import { useLoginUserMutation } from "../../features/auth/loginApi";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { login } from "../../features/auth/authSlice";
import { useDispatch } from "react-redux";

function Login() {
  const [user, setUser] = useState({ email: "", password: "" });

  const [loginUser] = useLoginUserMutation();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handelChange = (e) => {
    const { name, value } = e.target;
    setUser((prev) => ({ ...prev, [name]: value }));
  };

  const handleGlogin = () => {
    window.location.href = `${process.env.REACT_APP_SERVER}/auth/google`;
  };

  const handleManuallogin = async (e) => {
    e.preventDefault();
    try {
      // unwrap returns the actual data object parsed from JSON
      const response = await loginUser({
        email: user.email?.trim()?.toLowerCase(),
        password: user.password?.trim(),
      }).unwrap();

      // response is already the data
      // If your server returns { accessToken: "xxx", success: true }
      dispatch(login(response.accessToken));
      navigate("/dashboard");
      toast.success("Login successful");
    } catch (err) {
      console.error("Login failed", err);
      toast.error(err?.data?.message || "Login failed");
    }
  };

  return (
    <Sign
      handleGlogin={handleGlogin}
      handleManuallogin={handleManuallogin}
      handelChange={handelChange}
      user={user}
    />
  );
}

export default Login;
